import mass from '../../assets/img/icons/mass.png';
import length from '../../assets/img/icons/length.png';
import temperature from '../../assets/img/icons/temperature.png';
import area from '../../assets/img/icons/area.png';
import volume from '../../assets/img/icons/volume.png';
import velocity from '../../assets/img/icons/velocity.png';
import time from '../../assets/img/icons/time.png';
import angle from '../../assets/img/icons/angle.png';
import prefix from '../../assets/img/icons/prefix.png';
import color from '../../assets/img/icons/color.png';
import currency from '../../assets/img/icons/currency.png';
import cooking from '../../assets/img/icons/cooking.png';

export default {
  mass, length, temperature, area,
  volume, velocity, time, angle,
  prefix, color, currency, cooking
}
